var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKr = function SvgIconKr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M16.174 12c0 1.043-1.869 3.652-4.174 3.652S7.826 13.043 7.826 12a4.174 4.174 0 1 1 8.348 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M16.174 12a4.174 4.174 0 0 1-8.348 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.534 14.583-1.107 1.107.738.737 1.106-1.107zM15.689 16.427l-1.107 1.107.738.738 1.107-1.107zM19.747 16.795 18.641 17.9l.738.738 1.106-1.107zM17.903 18.64l-1.107 1.108.738.737 1.107-1.106zM18.64 15.69l-1.106 1.106.738.738 1.107-1.107zM16.796 17.534 15.69 18.64l.737.738 1.107-1.107zM15.69 5.358l2.95 2.952.738-.738-2.95-2.952zM14.583 6.466l1.107 1.107.737-.738-1.107-1.107zM16.427 8.31l1.107 1.107.738-.738-1.107-1.107zM16.795 4.252 17.9 5.36l.738-.738-1.107-1.106zM18.641 6.098l1.107 1.106.738-.737-1.107-1.107zM7.203 19.748l-2.951-2.951-.738.738 2.951 2.95zM8.31 18.64l-1.106-1.107-.738.738 1.107 1.107zM6.466 16.796 5.36 15.689l-.737.738 1.106 1.107zM9.417 17.534l-2.951-2.952-.738.738 2.951 2.951zM4.253 7.205l2.951-2.952-.738-.737-2.951 2.95zM5.358 8.31 8.31 5.358l-.738-.737L4.62 7.57zM6.467 9.417l2.951-2.951-.738-.738L5.73 8.679z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconKr;